<div>{{ message.prompt }} <a href="">{{ message.link }}</a></div>
